import React from 'react';

import ListItemText from '@material-ui/core/ListItemText';
import _capitalize from 'lodash/capitalize';

import SingleValue from './SingleValue';

const SingleValueWithSubtitle = (props) => {
  const {selectProps} = props;
  const {classes, size} = selectProps;
  return (
    <SingleValue {...props}>
      <ListItemText
        primary={props.children}
        secondary={props.data.subtitle}
        classes={{
          primary: classes[`primaryOptionText${_capitalize(size)}`],
          secondary: classes[`secondaryOptionText${_capitalize(size)}`],
        }}
      />
    </SingleValue>
  );
};

SingleValueWithSubtitle.muiName = 'SingleValueWithSubtitle';

export default SingleValueWithSubtitle;
